import { Controller } from "@hotwired/stimulus";
import "./component.scss"

export default class extends Controller {
  static targets = ["custom", "start", "end"];

  connect() {
    this.onDocumentClick = (event) => {
      if (this.hasCustomTarget && !this.customTarget.contains(event.target)) {
        this.customTarget.removeAttribute("open");
      }
    };
    this.onKeydown = (event) => {
      if (event.key === "Escape" && this.hasCustomTarget && this.customTarget.open) {
        this.customTarget.removeAttribute("open");
        this.customTarget.querySelector("summary")?.focus();
      }
    };

    document.addEventListener("click", this.onDocumentClick);
    document.addEventListener("keydown", this.onKeydown);
  }

  disconnect() {
    document.removeEventListener("click", this.onDocumentClick);
    document.removeEventListener("keydown", this.onKeydown);
  }

  syncDates() {
    if (!this.hasStartTarget || !this.hasEndTarget) return;

    if (this.endTarget.value) this.startTarget.max = this.endTarget.value;
    if (this.startTarget.value) this.endTarget.min = this.startTarget.value;
  }

  close(event) {
    event.preventDefault();
    this.customTarget.removeAttribute("open");
    this.customTarget.querySelector("summary")?.focus();
  }
}
